import { render, staticRenderFns } from "./EditValidatorMessageDetails.vue?vue&type=template&id=11172c88&"
import script from "./EditValidatorMessageDetails.vue?vue&type=script&lang=js&"
export * from "./EditValidatorMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports